// extracted by mini-css-extract-plugin
module.exports = {"main_nav":"main_nav-1e0YSyNo","box":"box-2hjS7aMr","ad":"ad-Z2DL3yuK","search":"search-2VSESzQU","logo":"logo-36zgkxlb","nav_box":"nav_box-2Yh5NKTE","userInfo":"userInfo-37XKD9S2"};